// import { validatePromotions } from './validatePromotions'
import { OrderParams, getOrderPriceSummary } from './getOrderPriceSummary'

import applyDiscountStrategy from '../discounts/applyDiscountStrategy'
import { DiscountConfiguration } from '@ca/common/types'

// This gets the final order summary with discounts applied
export const getFinalOrderSummary = (params: OrderParams) => {
  // Get the  full price of the order
  const price = getOrderPriceSummary(params)

  // Validate promotions and get the applicable discounts
  // const validatedPromotions = validatePromotions(params.order.promotions, price)

  const dealsEntries = Object.entries(params.deals)

  const dealDiscounts: DiscountConfiguration[] = []

  dealsEntries.forEach(([key, val]) => {
    const withBundle =
      val?.discounts.map((discount) => ({
        ...discount,
        bundle: key,
      })) || []
    dealDiscounts.push(...withBundle)
  })

  // const promoDiscounts = validatedPromotions.flatMap(
  //   (promotion) => promotion.discounts
  // )

  return applyDiscountStrategy(price, dealDiscounts, 'topDown', params)
}
